/**
 * Booking-progression gate for the Passenger AI-chat Confirm CTA.
 *
 * Deliberately does NOT depend on the fare `estimate`: the estimate is a passive
 * display quote and the backend recomputes the fare on request-ride, so an
 * estimate outage must never block a booking whose essentials — both addresses
 * confirmed with coordinates — are present. Kept in its own import-light module
 * so the gating condition can be unit-tested without the component's UI deps.
 */
export const canConfirmAiBooking = ({ booking, bothConfirmed }) =>
  !booking && !!bothConfirmed;
